export interface CheckListItem {
  description: string;
  isSystemTask: boolean;
  done: boolean;
  taskId: string;
  checkListItemId: string;
  relatedUrl: string;
}
